<template>
    <div>
        <div style="width: 100%;">
            <form @submit="save">
                <table style="width: 100%;">
                    <tr style="text-decoration: underline;">
                        <td>
                            #
                        </td>
                        <td @click="sortByField('name')">
                            Alternate Name
                            <div class="th-icon" v-if="sortOptions.sortByField === 'name'" style="display: inline-block;">
                                <i :class='sortOptions.sortOrder === "desc" && sortOptions.sortByField === "name" ? "fa fa-sort-up" : "fa fa-sort-down"'></i>
                            </div>
                        </td>
                        <td>
                            PID
                        </td>
                        <td>

                        </td>
                        <td>

                        </td>
                        <td>

                        </td>
                    </tr>
                    <tr v-for="row of rows">
                        <td>
                            {{ row.id }}
                        </td>
                        <td>
                            <div v-if="!row.edit">{{ row.name }}</div>
                            <b-form-input v-if="row.edit" type="text" v-model.trim="row.name" placeholder="Agency Name" />
                        </td>
                        <td>
                            <div v-if="!row.edit">{{ row.pid }}</div>
                            <b-form-input v-if="row.edit" type="text" v-model.trim="row.pid" placeholder="PID" />
                        </td>
                        <td >
                            <b-form-input class="empty-input" type="text" :disabled="true"  />
                        </td>
                        <td>
                            <b-form-input class="empty-input" type="text" :disabled="true"  />
                        </td>
                        <td>
                            <div v-if="!row.edit">
                                <a v-if="isAdmin" class="btn btn-primary" href="javascript:void(0);" @click="editRow(row.id)">Edit</a> <a class="btn btn-primary" href="javascript:void(0);" @click="deleteEntity(row.id)" v-if="isAdmin">Delete</a>
                            </div>
                            <div v-if="row.edit">
                                <a class="btn btn-primary" href="javascript:void(0);"
                                    @click="saveEditRow(row.id)">Save</a>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="isAdmin && showNewRow">
                        <td>

                        </td>
                        <td>
                            <b-form-input type="text" v-model="newRow.name" placeholder="Agency Name" />
                        </td>
                        <td>
                            <b-form-input type="text" v-model="newRow.pid" placeholder="PID" />
                        </td>
                        <td >
                            <b-form-input class="empty-input" type="text" :disabled="true"  />
                        </td>
                        <td>
                            <b-form-input class="empty-input" type="text" :disabled="true"  />
                        </td>
                        <td>
                            <input type="submit" class="btn btn-success" value="Add" />
                        </td>
                    </tr>
                </table>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            newRow: {
                id: 0,
                name: '',
                pid: '',
            },
            rows: [],
            showNewRow: true,
            isAdmin: true,
            sortOptions: { 
                sortOrder: 'desc',
                sortByField: 'name'
            },
        };
    },
    async created() {
        const permList = await this.$store.state.user.perms;
        if (Object.values(permList).indexOf("bundles.admin") > -1) {
            this.isAdmin = true;
        }
        this.getListData();
    },
    methods: {
        async save(e) {
            e.preventDefault();
            const rowReq = this.newRow
            let validateRes = await this.validateRowData(this.newRow.name, this.newRow.pid)
            console.log(validateRes);
            if (validateRes !== '') {
                this.notifyError(validateRes)
                return
            }
            const data = await this.$http.post(this.resources.Management.saveAlternateSeat, {
                ...this.newRow
            });
            this.newRow.name = "";
            this.newRow.pid = "";
            this.getListData();
        },
        async getListData() {
            const data = await this.$http.post(this.resources.Management.getAlternateSeat, {});
            for (let k in data.body.data) {
                data.body.data[k].edit = false;
            }
            this.rows = data.body.data;
            this.sortByField('name');
        },
        async deleteEntity(id) {
            id = parseInt(id);
            const data = await this.$http.post(this.resources.Management.deleteAlternateSeat, {
                id,
            });
            this.getListData();
        },
        async editRow(id) {
            this.showNewRow = false;
            for (let k in this.rows) {
                if (this.rows[k].id == id) {
                    this.rows[k].edit = true;
                }
                else {
                    this.rows[k].edit = false;
                }
            }
        },
        async saveEditRow(id) {
            let editRowData = {};
            for (let k in this.rows) {
                if (this.rows[k].id == id) {
                    editRowData = this.rows[k];
                }
            }
            
            this.showNewRow = true;
            // validate 
            let validateRes = await this.validateRowData(editRowData.name, editRowData.pid)
            if (validateRes !== '') {
                this.notifyError(validateRes)
                return
            }
            const data = await this.$http.post(this.resources.Management.saveAlternateSeat, {
                ...editRowData
            });
            this.getListData()
            
        },
        async validateRowData(dm_name, dm_pid) {
            if (dm_name == "") {
                return "name can't be empty";
            }
            // if (!this.validateStr(dm_name)) {
            //     return "Please enter a valid name";
            // }

            if (dm_pid == "") {
                return "Pid value can't be empty";
            }
            if (!this.validateStr(dm_pid)) {
                return "Please enter a valid pid value (without white spaces)";
            }
            
            return "";
        },
        validateStr(str) {
            const re = /(^[A-Za-z0-9-_]+$)/;
            console.log(re.test(str));
            if (re.test(str)) {
                return true;
            }
            return false;
        },
        sortByField(fieldName) {
            this.sortOptions.sortByField = fieldName
            if (this.sortOptions.sortOrder === 'desc') {
                this.sortOptions.sortOrder = 'asc'
            } else {
                this.sortOptions.sortOrder = 'desc'
            }

            const nonIntFields = ['name']
            if (! nonIntFields.includes(fieldName)) {
                if (this.sortOptions.sortOrder === 'desc') {
                    this.rows.sort((a, b) => (parseInt(a[fieldName]) < parseInt(b[fieldName])) ? 1 : -1)
                } else {
                    this.rows.sort((a, b) => (parseInt(a[fieldName]) > parseInt(b[fieldName])) ? 1 : -1)
                }
            } else {
                // Remove spaces from the field
                for (let k in this.rows) { 
                    this.rows[k][fieldName] = this.rows[k][fieldName].trim()
                }
                if (this.sortOptions.sortOrder === 'desc') {
                    this.rows.sort((a, b) => (a[fieldName].toLowerCase() < b[fieldName].toLowerCase()) ? 1 : -1)
                } else {
                    this.rows.sort((a, b) => (a[fieldName].toLowerCase() > b[fieldName].toLowerCase()) ? 1 : -1)
                }
            }
        },
    },
}
</script>

<style scoped>

    .empty-input {
        width: 100%;
        border: none;
        background-color: transparent;   
    }
</style>
